import { useExpensesStore } from '../store/expensesStore'
import { useDeleteExpenseMutation } from '../hooks'

import type { ApiError } from '@/types/api'
import { Modal } from '@/components/custom/modal'
import LoadingButton from '@/components/custom/loading-button'
import { notifyRequestError } from '@/utils/notifyRequestError'
import { formatCurrency } from '@/utils/currencyUtils'

export function DeleteExpense({
  id,
  trigger,
  open,
  onClose,
}: {
  id: string | null
  trigger?: React.ReactNode
  open?: boolean
  onClose?: () => void
}) {
  const { mutateAsync: deleteExpenseMutation, isPending } =
    useDeleteExpenseMutation()

  const expenses = useExpensesStore((s) => s.expenses)
  const expense = expenses.find((u) => u._id === id)
  const handleDeleteItem = async () => {
    if (!expense) return

    try {
      await deleteExpenseMutation(expense._id)
      onClose?.()
    } catch (error) {
      notifyRequestError(error as ApiError, 'Failed to delete expense')
    }
  }

  return (
    <Modal
      open={open}
      onClose={onClose}
      trigger={trigger}
      title="Delete Expense"
    >
      <div className="space-y-4">
        <p>
          Are you sure you want to delete the expense refund from{' '}
          <strong>{expense?.requester}</strong>, amounting to{' '}
          <strong>{formatCurrency(expense?.amount || 0)}</strong>
          ?
          <br />
          <span className="text-red-500 font-semibold">
            This action is permanent and cannot be undone.
          </span>
        </p>
        <LoadingButton
          type="submit"
          className="w-full"
          isLoading={isPending}
          disabled={isPending}
          onClick={handleDeleteItem}
        >
          {isPending ? 'Deleting...' : 'Delete'}
        </LoadingButton>
      </div>
    </Modal>
  )
}
